export const LANDING = '/';
export const FINISH_SIGNUP = '/finish-signup';

export const HOME = '/home';
export const CONNECT_ID = '/connect-id';
export const CONNECT_ID_SUCCESS = '/success';
export const CONNECT_ID_ERROR = '/error';

export const REGISTER = '/register';
export const VERIFY_ACCOUNT = '/verify/confirm-account';
export const LOGIN = '/login';
export const FORGOT_PASSWORD = '/forgot-password';
export const RESET_ACCOUNT = '/reset';
export const RESET_PASSWORD = '/auth/reset-password';

export const LOGOUT = '/logout';

// admin

// users
export const VIEW_USER = '/user';

// export const VIEW_DISCOVER = '/discover';
export const VIEW_DISCOVER_CATEGORIES = '/categories';
export const VIEW_DISCOVER_MERCHANT = '/merchant'
export const VIEW_DISCOVER_MERCHANT_OFFER_DETAILS = '/merchant-offer-details';
export const VIEW_DISCOVER_REDEEM = '/redeem-offer'; 
export const VIEW_DISCOVER_CONFIRM_TRANSACTION = '/confirm-transaction';
export const VIEW_PROFILE = '/profile';

// customers

// merchants
export const VIEW_MERCHANT = '/merchant';
export const VIEW_ALL_MERCHANTS = '/all-merchants';

// dicovery
export const DISCOVER = '/discover';

// offers
export const FIND_OFFERS = '/offers';
export const VIEW_OFFER = '/offer';
export const VIEW_OFFER_DETAILS = '/offers/:offerId';
export const FIND_CATEGORY = '/category'
export const VIEW_CATEGORY_OFFER = '/category/:categoryId';

// account
export const ACCOUNT = '/account';
export const CHANGE_PASSWORD = '/change-password/:key';
export const ACCOUNT_SUSPENDED = '/account-suspended';
export const RESEND_EMAIL = '/resend-email';


// pofile
export const PROFILE = '/profile';
export const ABOUT_US = '/about';
export const POINTS_OVERVIEW = '/points-overview';
export const CONVERT_POINTS = '/convert-points';
export const HELP_AND_SUPPORT = '/help-and-support';
export const REFERRAL = '/referral';
export const LEGAL = '/legal';
export const PRIVACY_POLICY = '/privacy-policy';
export const TERMS_CONDITIONS = '/terms-and-conditions';
export const APP_SETTINGS = '/app-settings';
export const TOP_UP_LIMIT = '/top-up-limit';
export const CONFIRM_TOP_UP_LIMIT = '/confirm-Top-up-Limit';
export const ACCOUNT_DETAILS = '/account-details';
export const CHANGE_EMAIL_DETAILS = '/change-email-details';
export const CHANGE_EMAIL_OTP = '/change-email-otp';
export const PERSONAL_DETAILS = '/personal-details';
export const CHANGE_PHONE_NUMBER = '/change-phone-number';
export const CHANGE_PHONE_NUMBER_DETAILS_OTP = '/change-phone-number-otp';
export const CHANGE_PASSWORD_PROFILE = '/change-password';
export const MANAGE_ID_CARDS = '/manage-id-cards';
export const REDEMPTION_HISTORY = '/redemption-history';
export const REDEMPTION_DETAILS = '/redemption-details';
export const CHANGE_PIN = '/change-pin';
export const CLOSE_ACCOUNT ='/close-account';
export const TIMELINE = '/profile/timeline';
export const ACTIVITY = '/profile/activity';
export const STREAMS = '/profile/streams';
export const REFERRALS = '/profile/referrals';

//wallet
export const VIEW_WALLET = '/wallet';
export const VIEW_SEND_MONEY = '/send-money';
export const VIEW_SEND_INFO_DETAILS = '/send-info-details';
export const VIEW_SEND_MONEY_DETAILS = '/send-money-details';
export const VIEW_WALLET_CONFIRM_TRANSACTION = '/confirm-transaction-wallet';
export const VIEW_SEND_MONEY_CONFIRMATION = '/send-money-confirmation';

// insight
export const VIEW_INSIGHT = '/insight';
export const VIEW_TRANSACTION_DETAIL = '/transaction-detail/:transactionId';

// alert
export const ALERTS = '/alerts';

// ticket
export const TICKETS = "/tickets";
export const CREATE_TICKET = "/submit-ticket";

// account pending deletion
export const ACCOUNT_PENDING_DELETION = '/account-pending-deletion';
